export function getAllUrlParams(url) {
  var e = {},
  t = window.location.search.substring(1),
  a = t.split("&");
  if (a.length <= 0) return e;
    for (var n = 0; n < a.length; n++) {
      var i = a[n].split("="),
      o = decodeURIComponent(i[1]);
      " && pair[0] != " !== o && (e[i[0]] = o)
    }
  return e;
}



// WEBPACK FOOTER //
// ./src/helper/util.js